import { render, staticRenderFns } from "./PollPreview.vue?vue&type=template&id=1977315e&scoped=true&"
import script from "./PollPreview.vue?vue&type=script&lang=ts&"
export * from "./PollPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PollPreview.vue?vue&type=style&index=0&id=1977315e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977315e",
  null
  
)

export default component.exports